import { composeIO } from 'react-compose-io'
import { ControleComissaoHistoricoClassificacaoView } from './ControleComissaoHistoricoClassificacao.View'
import { controleComissaoHistoricoClassificacaoIO } from './ControleComissaoHistoricoClassificacao.IO'

export const ControleComissaoHistoricoClassificacao = composeIO(ControleComissaoHistoricoClassificacaoView, controleComissaoHistoricoClassificacaoIO)
